<div class="form-group label-static is-empty"
     [class]="{'is-focused': focused, 'input--filled': !!formControl.value, 'has-error': !!errors() }">
  <label [htmlFor]="controlName()" class="control-label">
    {{ schemaTranslations()?.getFieldTranslation(controlName()) }}
    @if (required) {
      <span class="required">*</span>
    }
  </label>
  @if (inputType === 'checkbox') {
    <input [formControl]="formControl"
           class="form-control"
           type="checkbox"
           [readonly]="readonly()"
           [id]="controlName()"
           appFocusable
           (onFocusChange)="focused = $event"
           [autocomplete]="AUTOCOMPLETE[controlName()]"/>
  } @else {
    <input [formControl]="formControl"
           class="form-control"
           [type]="inputType"
           [step]="inputSteps"
           [readonly]="readonly()"
           [id]="controlName()"
           appFocusable
           (onFocusChange)="focused = $event"
           [autocomplete]="AUTOCOMPLETE[controlName()]"/>
  }

</div>
